export default {
    STOP_PROCESS: "Остановка...",
    STOP: "Остановить"
};
